import { getLanguages,translate } from '../services';

export const translateProperty = ( props, defaultTranslation ) => {
  if( !props ) {
    return defaultTranslation;
  }

  return props[getLanguages().firstOrDefault( lang => props[lang] )] || defaultTranslation;
};

export const getProductDescription = (product,Culture_lang, isReadyAssembled) => {
  var language = getLanguages().first();
  var descriptionLanguage='';
  const ProductNotavailable="产品在您的国家不可用";
  if(!language){ 
    if(Culture_lang!=''){
      language=Culture_lang;
    }  
  }
  descriptionLanguage = `Translation.${'EN'}`;
  if(product?.code?.startsWith('V4AC')){
    descriptionLanguage = `Translation.${'ZH'}`;

  }
  if(product) {
    const descriptionMainLanguage= `SalesText.${language}`
    if(product == "1SDA050230R1")
    {
    const description = translate( 'DummyCodeDescription') ;
        return description;
    }
    else{
      const translatedDescription = product.properties?.filter(prop => prop["name"] === descriptionLanguage).map(c=>{return c.value});
      const originalDescription = product.properties?.filter(prop => prop["name"] === "Description")?.select(val => val.value).firstOrDefault();
      const translatedMainDescription= product.properties?.filter(prop => prop["name"] === descriptionMainLanguage).map(c=>{return c.value});
      product.descriptionDkLso=translatedMainDescription;
      if(!translatedDescription && !originalDescription && !translatedMainDescription && !product.description ){
       return ProductNotavailable;
      }
      return translatedDescription && translatedDescription.length > 0 ? translatedDescription.firstOrDefault() : (product.description || originalDescription) ;
    }
  }
  let translatedDescriptionChild = [];
  let translatedDescription = [];
  const descriptionMainLanguage= `SalesText.${language}`
  if ( product && isReadyAssembled) {
    translatedDescription =  product.properties?.filter( prop => prop["name"] === descriptionLanguage ).map( c => { return c.value } );
    const originalDescription = product.properties?.filter(prop => prop["name"] === "Description")?.select(val => val.value).firstOrDefault();
    const translatedMainDescription= product.properties?.filter(prop => prop["name"] === descriptionMainLanguage)?.map(c=>{return c.value});
    if(translatedMainDescription && translatedMainDescription.length > 0 ){
      product.descriptionDkLso=translatedMainDescription[0];
    }
    if(product.children){
     product.children.forEach((ch)=>{
       translatedDescriptionChild.push(ch.name + '  ' + ch.properties?.filter( prop => prop["name"] === descriptionLanguage ).map( c => { return c.value } ));
     })
     return translatedDescription && translatedDescriptionChild && translatedDescription.length > 0 ? (product.name +' '+ translatedDescription.concat(translatedDescriptionChild)).split(",") : ( product.description || originalDescription ); 
   // return translatedDescription && translatedDescription.length > 0 ? translatedDescription.firstOrDefault() : ( product.name + ' ' + product.description || originalDescription );
 }}
 else{
    translatedDescription =  product.properties?.filter( prop => prop["name"] === descriptionLanguage ).map( c => { return c.value } );
   const originalDescription = product.properties?.filter( prop => prop["name"] === "Description" )?.select( val => val.value ).firstOrDefault();
   const translatedMainDescription= product.properties?.filter(prop => prop["name"] === descriptionMainLanguage)?.map(c=>{return c.value});
   if(translatedMainDescription && translatedMainDescription.length > 0 ){
    product.descriptionDkLso=translatedMainDescription[0];
   } 
   return translatedDescription && translatedDescription.length > 0 ? translatedDescription.firstOrDefault() : (product.description || originalDescription) ;
  }
}